import BackgroundVideo from "../components/BackgroundVideo";
import Logo from "../assets/images/logo.png"

const HomeScreen = () => {
    return (
        <>
            <BackgroundVideo />
            <section id="homescreen" className="hero-section container py-5">
                <p className="pulse">Coming Soon</p>
                <img src={Logo} alt="Dyed To Self" className="logo timed-spin" />
                <h1 className="branding-text">🌈 Dyed to self. <br />
                    🔥 Hand-dyed with purpose. <br />
                    ✨ Inspired by transformation.
                </h1>
            </section>
        </>
    );
};

export default HomeScreen;